require('./bootstrap')

require('bootstrap')
import {Calendar} from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import momentPlugin from "@fullcalendar/moment"
import bootstrap5Plugin from "@fullcalendar/bootstrap5";
import ruLocale from "@fullcalendar/core/locales/ru";
import tippy from "tippy.js";
import toggleMobileMenu from "./menu";
import Swiper, {Autoplay, Navigation, Pagination,} from 'swiper';
import 'virtual-select-plugin/dist/virtual-select.min';
import { Fancybox } from "@fancyapps/ui";

window.toastr = require('toastr')

$(document).ready(() => {

  Fancybox.bind("[data-fancybox]", {});

  toggleMobileMenu()
  $('.header__burger').on('click', setHeaderPadding)

  const $sectionTop = $('.section-top__main')
  const $header = $('.header')
  function setHeaderPadding() {
    $sectionTop.css('padding-top', parseInt($header.css('height')) + 40 + 'px')
    if (window.innerWidth < 993) {
      $sectionTop.css('padding-top', parseInt($header.css('height')) + 35 + 'px')
    }
  }
  setHeaderPadding()
  $(window).on('resize', () => setHeaderPadding())

  $('input[type="tel"]').inputmask('+7 (999) 999-9999')

  const calendarItem = $('#mycalendar')

  if (calendarItem.length === 1) {
    const calendar = new Calendar(calendarItem.get(0), {
      plugins: [dayGridPlugin, momentPlugin, bootstrap5Plugin],
      displayEventTime: false,
      height: 625,
      titleFormat: 'MMMM, YYYY' + 'г.',
      initialView: 'dayGridMonth',
      themeSystem: 'bootstrap5',
      editable: false,
      locale: ruLocale,
      events: {
        url: '/groups/calendar',
        extraParams: {
          '_token': $('meta[name="csrf-token"]').attr('content'),
        },
        method: 'POST',
      },
      eventDidMount: info => {
        tippy(info.el, {
          content: info.event.extendedProps.description,
          allowHTML: true
        })
      }
    })

    calendar.render()
  }

  calendarItem.find('.btn').removeClass('btn-primary').addClass('btn-secondary text-white')

  new Swiper('.home-moments__slider', {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    loop: false,
    navigation: {
      nextEl: '.home-moments__arrow_right',
      prevEl: '.home-moments__arrow_left',
    },
    pagination: {
      el: ".home-moments__pagination",
      clickable: true,
    }
  })
})